import React, {Component} from "react";
import './Contact.css'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faGithub} from '@fortawesome/free-brands-svg-icons'
import {faLinkedin} from '@fortawesome/free-brands-svg-icons'
import {faFacebook} from '@fortawesome/free-brands-svg-icons'


class Contact extends Component {

    render() {
        return (
            <section className="Contact" id={"section5"}>
                    <h2 style={{marginTop: "50px"}}>Contact</h2>
                    <div className="hr"/>
                    <div className="contactIcons">
                        <a href={"https://github.com/veskol1"} className="contactIconGit"> <FontAwesomeIcon icon={faGithub}/></a>
                        <a href={"https://www.linkedin.com/in/vesko-latchev/"} className="contactIconLinkedin"> <FontAwesomeIcon icon={faLinkedin}/></a>
                        <a href={"https://www.facebook.com/veskol1"} className="contactIconFacebook"> <FontAwesomeIcon icon={faFacebook}/></a>
                    </div>
            </section>
        )
    }

}

export default Contact
